import { useEffect, useRef, useState } from 'react'
import { SonDir, CatalogueItem, Collapse, ParentDir } from './atoms'
import { Arrow } from './svg/arrow'
import { ArtComponent, DirComponent, SubDir } from '../../interface'
import { useLocation } from '@reach/router'

export const traversalDir = ({
  item,
  level,
  currentSlug,
  rootSlug,
}: {
  item: ArtComponent | DirComponent
  level: number
  currentSlug: string
  rootSlug: string
}) => {
  if ((item as ArtComponent).fox_support_arts) {
    return (item as ArtComponent).fox_support_arts.map((item) => (
      <CatalogueItem
        key={item.id}
        $level={level}
        $isActive={currentSlug === item.slug}
        to={`/support/${rootSlug}/${item.slug}`}
      >
        {item.dir_name}
      </CatalogueItem>
    ))
  }
  if ((item as DirComponent).fox_support_dirs) {
    return (item as DirComponent).fox_support_dirs.map((item) => (
      <CollapseComponent
        key={item.id}
        level={level}
        subDir={item.sub_dir}
        name={item.name}
        slug={item.slug}
        currentSlug={currentSlug}
        rootSlug={rootSlug}
      />
    ))
  }
  return ''
}

interface Props {
  level: number
  subDir: SubDir | null
  name: string
  slug: string
  currentSlug: string
  rootSlug: string
}

export const CollapseComponent = ({ level, subDir, name, slug, currentSlug, rootSlug }: Props) => {
  const { pathname } = useLocation()
  const questionRef = useRef<HTMLDivElement | null>(null)
  const [isExpand, setIsExpand] = useState(pathname.includes(slug))
  const [collapseHeight, setCollapseHeight] = useState(40)

  useEffect(() => {
    questionRef.current && setCollapseHeight(questionRef.current.offsetHeight)
  }, [])

  const handleCollapse = () => {
    setIsExpand((v) => !v)
  }

  return (
    <Collapse $isExpand={isExpand} $height={collapseHeight} $level={level}>
      <ParentDir
        ref={questionRef}
        onClick={handleCollapse}
        $level={level}
        $isExpand={isExpand}
        $isActive={currentSlug === slug}
      >
        {name}
        <Arrow />
      </ParentDir>
      <SonDir>
        {subDir?.map((item) =>
          traversalDir({ item, level: level + 1, currentSlug, rootSlug: `${rootSlug}/${slug}` }),
        )}
      </SonDir>
    </Collapse>
  )
}
